export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: ArticleContent[];
  categoryId: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  featured: boolean;
  viewCount: number;
}

export interface ArticleContent {
  type: 'paragraph' | 'image' | 'subtitle' | 'tip';
  value: string;
  caption?: string;
}

export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'breastfeeding-daily',
    name: '哺乳日常',
    description: '记录新手妈妈哺乳生活中的温馨、搞笑与真实瞬间，用漫画呈现最真实的哺乳体验',
    icon: 'ri-heart-pulse-line',
    articleCount: 24,
  },
  {
    id: 'cat-2',
    slug: 'breastfeeding-knowledge',
    name: '母乳喂养知识',
    description: '用生动有趣的漫画图解母乳喂养专业知识，让育儿知识不再枯燥难懂',
    icon: 'ri-book-read-line',
    articleCount: 18,
  },
  {
    id: 'cat-3',
    slug: 'parent-child-moments',
    name: '亲子互动',
    description: '捕捉妈妈与宝宝之间温暖亲密的互动瞬间，记录成长路上的每一个甜蜜时刻',
    icon: 'ri-hearts-line',
    articleCount: 20,
  },
  {
    id: 'cat-4',
    slug: 'new-mom-growth',
    name: '新手妈妈成长记',
    description: '从手足无措到得心应手，记录新手妈妈在育儿路上的蜕变与成长故事',
    icon: 'ri-seedling-line',
    articleCount: 15,
  },
  {
    id: 'cat-5',
    slug: 'funny-comics',
    name: '趣味育儿漫画',
    description: '用幽默诙谐的视角看待育儿生活，让每位妈妈在笑声中找到共鸣与力量',
    icon: 'ri-emotion-laugh-line',
    articleCount: 22,
  },
  {
    id: 'cat-6',
    slug: 'illustrated-guide',
    name: '哺乳知识图解',
    description: '以图解形式呈现哺乳姿势、喂养技巧等实用信息，一目了然轻松掌握',
    icon: 'ri-lightbulb-line',
    articleCount: 12,
  },
];

export const articles: Article[] = [
  {
    id: 'art-1',
    slug: 'first-breastfeeding-memory',
    title: '第一次哺乳：那些手忙脚乱又无比珍贵的瞬间',
    excerpt: '还记得第一次把宝宝抱到胸前的那一刻吗？紧张、期待、还有点不知所措——这是每位妈妈都经历过的哺乳初体验。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20a%20new%20mother%20holding%20her%20newborn%20baby%20for%20the%20first%20breastfeeding%20attempt%2C%20soft%20pastel%20colors%2C%20cozy%20nursery%20setting%20with%20gentle%20sunlight%2C%20tender%20and%20emotional%20moment%2C%20Japanese%20manga%20inspired%20art%20style%2C%20clean%20line%20work%2C%20warm%20cream%20and%20soft%20pink%20tones%2C%20simple%20background%20with%20minimal%20decor&width=1600&height=900&seq=comic-art1-01&orientation=landscape', caption: '第一次哺乳的紧张与期待' },
      { type: 'paragraph', value: '凌晨三点，病房里静悄悄的。小宝贝终于醒了，小嘴巴一张一合地寻找着。护士说过这是觅食反射，可真正面对这一刻，我还是紧张得手心冒汗。' },
      { type: 'paragraph', value: '"来，把他贴近你的胸口，让他的下巴先接触乳房。" 月嫂大姐的声音温柔而坚定。我笨拙地调整着姿势，宝宝的小手在空中挥舞，似乎比我还着急。' },
      { type: 'subtitle', value: '第一次的挑战' },
      { type: 'paragraph', value: '说实话，第一次哺乳远没有想象中那么唯美。乳头传来的刺痛让我倒吸一口凉气，宝宝也因为吸不到奶而急得小脸通红。那一刻，我真的怀疑自己能不能做好一个妈妈。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Humorous%20Japanese%20manga%20style%20illustration%20of%20a%20struggling%20new%20mother%20trying%20to%20breastfeed%20with%20a%20crying%20baby%2C%20comedic%20exaggerated%20expressions%2C%20soft%20pastel%20warm%20colors%2C%20clean%20minimal%20background%2C%20gentle%20humor%2C%20relatable%20parenting%20moment&width=1600&height=900&seq=comic-art1-02&orientation=landscape', caption: '手忙脚乱的新手妈妈' },
      { type: 'tip', value: '💡 小贴士：第一次哺乳时尽量放松肩膀，可以在背后垫一个枕头。宝宝含乳时嘴巴要张得够大，含住大部分乳晕而非仅仅是乳头。' },
      { type: 'paragraph', value: '但慢慢地，我们都找到了节奏。宝宝的小脸蛋贴着我的胸口，小拳头慢慢松开，呼吸变得均匀而满足。那一刻，所有的疼痛和焦虑都化成了满满的幸福感。' },
      { type: 'paragraph', value: '这就是成为妈妈的第一课——在混乱中找到秩序，在疼痛中感受爱。每一个母乳妈妈都是这样一步步走过来的，我们都是彼此的镜子。' },
    ],
    categoryId: 'cat-1',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20warm%20illustration%20of%20a%20mother%20breastfeeding%20her%20newborn%20in%20a%20cozy%20sunlit%20room%2C%20soft%20pastel%20pink%20and%20cream%20tones%2C%20Japanese%20manga%20art%20style%2C%20emotional%20tender%20moment%2C%20clean%20simple%20background%2C%20motherhood%20art&width=800&height=500&seq=comic-art1-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-03-15',
    readTime: 5,
    tags: ['哺乳初体验', '新手妈妈', '母乳喂养', '育儿日记'],
    featured: true,
    viewCount: 12850,
  },
  {
    id: 'art-2',
    slug: 'correct-latch-position',
    title: '漫画图解：正确的哺乳含乳姿势，告别乳头疼痛',
    excerpt: '乳头疼痛是很多母乳妈妈都会遇到的问题，但正确的含乳姿势可以大大改善。用漫画一步步教你如何让宝宝正确含乳。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Educational%20illustration%20showing%20correct%20breastfeeding%20latch%20position%20in%20Japanese%20manga%20style%2C%20step%20by%20step%20demonstration%2C%20soft%20warm%20pastel%20colors%2C%20clean%20minimal%20background%2C%20medical%20accuracy%20with%20cute%20art%20style%2C%20cream%20and%20soft%20pink%20tones&width=1600&height=900&seq=comic-art2-01&orientation=landscape', caption: '正确含乳姿势图解' },
      { type: 'paragraph', value: '含乳姿势是母乳喂养中最关键的技术之一。正确的含乳不仅能让宝宝高效吃到奶，更能保护妈妈的乳头不受伤害。今天我们用漫画来详细讲解。' },
      { type: 'subtitle', value: '第一步：找准时机' },
      { type: 'paragraph', value: '当宝宝出现觅食信号时——比如小嘴张合、舔嘴唇、转头寻找——就是哺乳的最佳时机。不要等到宝宝大哭才开始，那时候宝宝情绪激动，含乳会更加困难。' },
      { type: 'subtitle', value: '第二步：正确抱姿' },
      { type: 'paragraph', value: '将宝宝的身体完全转向你，保持"肚子贴肚子"的姿势。宝宝的头、颈、背应该在一条直线上，不需要扭头才能含住乳房。一只手托住乳房，大拇指在上，其余四指在下，远离乳晕。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Cute%20manga%20style%20diagram%20showing%20proper%20breastfeeding%20holding%20position%2C%20mother%20and%20baby%20tummy%20to%20tummy%2C%20soft%20gentle%20colors%2C%20educational%20illustration%2C%20warm%20lighting%2C%20simple%20clean%20background&width=1600&height=900&seq=comic-art2-02&orientation=landscape', caption: '正确的哺乳抱姿' },
      { type: 'tip', value: '💡 小贴士：使用哺乳枕可以帮助维持舒适的姿势，减少手臂和肩背的疲劳。记住四个字——"胸贴胸、腹贴腹"。' },
      { type: 'subtitle', value: '第三步：引导含乳' },
      { type: 'paragraph', value: '用乳头轻轻触碰宝宝的上唇，引导他张大嘴巴（像打哈欠一样）。当宝宝嘴巴张到最大时，迅速将宝宝贴近乳房，让他的下巴先接触乳房，然后上唇包住乳晕。' },
      { type: 'paragraph', value: '正确含乳的标志：宝宝的嘴巴像小鱼一样外翻，下巴紧贴乳房，鼻子微微离开乳房或轻轻触碰，你能看到宝宝有节奏的吸吮和吞咽动作。' },
    ],
    categoryId: 'cat-2',
    coverImage: 'https://readdy.ai/api/search-image?query=Educational%20cute%20illustration%20of%20correct%20breastfeeding%20latch%20technique%2C%20Japanese%20manga%20style%2C%20soft%20pastel%20colors%2C%20step%20by%20step%20visual%20guide%2C%20warm%20cream%20and%20pink%20tones%2C%20clean%20background&width=800&height=500&seq=comic-art2-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-03-20',
    readTime: 8,
    tags: ['含乳姿势', '哺乳技巧', '乳头护理', '图解'],
    featured: true,
    viewCount: 22100,
  },
  {
    id: 'art-3',
    slug: 'night-feeding-comics',
    title: '凌晨三点的哺乳灯：那些只有妈妈懂的深夜故事',
    excerpt: '当整个城市都在沉睡，哺乳妈妈们却在微弱的夜灯下开始了新一轮的战斗。这是属于我们的深夜英雄故事。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=A%20mother%20breastfeeding%20her%20baby%20at%203%20AM%20in%20a%20dimly%20lit%20room%2C%20soft%20warm%20night%20light%20glow%2C%20tired%20but%20loving%20expression%2C%20Japanese%20manga%20illustration%20style%2C%20quiet%20nighttime%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20cozy%20bedroom%20setting&width=1600&height=900&seq=comic-art3-01&orientation=landscape', caption: '凌晨的哺乳时光' },
      { type: 'paragraph', value: '窗外一片漆黑，手机屏幕显示 03:17。宝宝的哼哼声准时响起，就像装了一个精准的生物闹钟。我揉揉惺忪的睡眼，摸黑打开了那盏特意买的最暗档位的哺乳灯。' },
      { type: 'paragraph', value: '这样的深夜哺乳，从宝宝出生到现在已经持续了四个多月。从一开始的痛苦挣扎，到现在竟然成了我和宝宝之间最私密的约定时刻。' },
      { type: 'subtitle', value: '深夜哺乳间的秘密' },
      { type: 'paragraph', value: '你有没有发现，深夜里宝宝的吸吮格外温柔？也许是因为他也困，也许是因为深夜的安静让一切都慢了下来。在这独属于我们两个人的时光里，我常常会不自觉地摸着宝宝的小脑袋，感受他柔软的头发和温热的体温。' },
      { type: 'tip', value: '💡 小贴士：夜间哺乳时尽量保持环境安静昏暗，不要开大灯或看电视，这样有助于宝宝吃完后快速入睡。床边备好水杯和小零食，补充妈妈的水分和能量。' },
      { type: 'paragraph', value: '有时候我会刷手机打发时间，看到育儿群里其他妈妈也在深夜活跃着。大家互相发个"辛苦了"的表情包，虽然没有更多言语，但那种"我不孤单"的感觉，真的是一种莫大的安慰。' },
    ],
    categoryId: 'cat-1',
    coverImage: 'https://readdy.ai/api/search-image?query=Night%20time%20breastfeeding%20scene%20with%20mother%20and%20baby%20under%20soft%20warm%20light%2C%20Japanese%20manga%20style%2C%20cozy%20bedroom%20atmosphere%2C%20soft%20amber%20glow%2C%20peaceful%20and%20intimate%2C%20pastel%20colors&width=800&height=500&seq=comic-art3-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-03-25',
    readTime: 6,
    tags: ['深夜哺乳', '夜奶', '妈妈日常', '育儿共鸣'],
    featured: true,
    viewCount: 18920,
  },
  {
    id: 'art-4',
    slug: 'baby-smile-after-feeding',
    title: '吃饱后的微笑：宝宝哺乳后那抹让一切辛苦都值得的笑容',
    excerpt: '辛苦喂奶半小时，腰酸背痛手发麻，但宝宝松开乳头后露出的那抹满足微笑，瞬间融化了一切疲惫。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Adorable%20baby%20with%20milk%20drunk%20smile%20after%20breastfeeding%2C%20content%20and%20sleepy%20expression%2C%20Japanese%20manga%20illustration%20style%2C%20soft%20dreamy%20pastel%20colors%2C%20warm%20pink%20and%20cream%20tones%2C%20simple%20cozy%20background%2C%20heartwarming%20scene&width=1600&height=900&seq=comic-art4-01&orientation=landscape', caption: '哺乳后的满足微笑' },
      { type: 'paragraph', value: '世界上最治愈的画面是什么？对我来说，就是宝宝吃饱奶之后松开乳头，小脸蛋上浮现出的那抹满足的微笑——我们妈妈圈里戏称为"奶醉"。' },
      { type: 'paragraph', value: '这种笑容和平时逗笑完全不同。它带着一种本能的满足感，小嘴巴微微上翘，眼睛半睁半闭，整个人软绵绵地靠在你的胸口，像是在说"妈妈，我吃饱了，好幸福呀"。' },
      { type: 'subtitle', value: '笑容背后的科学' },
      { type: 'paragraph', value: '其实这种"奶醉笑"是有科学依据的哦。母乳中含有一种叫做胆囊收缩素（CCK）的激素，它能让宝宝产生饱腹感和满足感。加上吸吮带来的安抚作用和妈妈的体温带来的安全感，宝宝自然会露出最放松、最满足的表情。' },
      { type: 'paragraph', value: '每次看到这个笑容，我都会忍不住掏出手机拍照。虽然先生总说每张都差不多，但在我眼里，每一张都是独一无二的小确幸。这些照片组成了我手机里最珍贵的相册。' },
    ],
    categoryId: 'cat-3',
    coverImage: 'https://readdy.ai/api/search-image?query=Heartwarming%20illustration%20of%20a%20baby%20with%20satisfied%20milk%20smile%20after%20feeding%2C%20mother%20looking%20down%20lovingly%2C%20Japanese%20manga%20style%2C%20soft%20dreamy%20pastel%20tones%2C%20warm%20cozy%20atmosphere&width=800&height=500&seq=comic-art4-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-04-02',
    readTime: 4,
    tags: ['亲子互动', '宝宝微笑', '哺乳时光', '温暖瞬间'],
    featured: false,
    viewCount: 15630,
  },
  {
    id: 'art-5',
    slug: 'breastfeeding-in-public',
    title: '公共场所哺乳：从紧张不安到自信从容的心路历程',
    excerpt: '第一次在公共场所哺乳，我恨不得把自己藏进地缝里。但慢慢地，我学会了坦然面对——喂饱宝宝是天经地义的事。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=A%20mother%20discreetly%20breastfeeding%20her%20baby%20in%20a%20public%20park%20under%20a%20tree%2C%20peaceful%20scene%2C%20Japanese%20manga%20illustration%20style%2C%20soft%20natural%20lighting%2C%20warm%20pastel%20colors%2C%20gentle%20atmosphere%2C%20empowering%20message&width=1600&height=900&seq=comic-art5-01&orientation=landscape', caption: '公园里从容哺乳的妈妈' },
      { type: 'paragraph', value: '宝宝两个月大的时候，我第一次鼓起勇气带他出门。一切都很顺利——直到他在商场的母婴室外开始嚎啕大哭。那声音撕心裂肺，我手忙脚乱地解开衣服，用哺乳巾把自己裹得像一个移动帐篷。' },
      { type: 'paragraph', value: '我感觉所有人的目光都集中在我身上。虽然实际上可能根本没人在意，但那种被围观的感觉让我浑身不自在。汗水顺着脖子流下来，宝宝在哺乳巾下也不安分，简直是一场灾难。' },
      { type: 'subtitle', value: '转变的契机' },
      { type: 'paragraph', value: '真正让我改变的是一次在咖啡厅的经历。一位老奶奶走过来，我以为她要说什么不好听的话，结果她微笑着说："姑娘，不用遮得那么辛苦，喂孩子是天底下最自然的事。"她告诉我，四十年前她也是这么喂大三个孩子的。' },
      { type: 'paragraph', value: '从那以后，我慢慢放下了心理包袱。我买了漂亮的哺乳衣，练习了各种方便的姿势。现在，我可以在公园的长椅上、商场的休息区、甚至朋友聚会上，从容地喂宝宝而不觉得尴尬。' },
      { type: 'tip', value: '💡 小贴士：带宝宝出门前可以查好附近母婴室的位置；备一件宽松的开衫或专用哺乳巾，选择让自己舒适的穿着方式；记住，你有权利在任何地方喂饱你的宝宝。' },
    ],
    categoryId: 'cat-4',
    coverImage: 'https://readdy.ai/api/search-image?query=Confident%20mother%20breastfeeding%20in%20public%20park%2C%20natural%20and%20empowered%2C%20Japanese%20manga%20art%20style%2C%20soft%20sunlight%2C%20warm%20pastel%20colors%2C%20gentle%20and%20positive%20vibe&width=800&height=500&seq=comic-art5-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-04-08',
    readTime: 7,
    tags: ['公共场所哺乳', '新手妈妈', '心理成长', '哺乳权利'],
    featured: false,
    viewCount: 19600,
  },
  {
    id: 'art-6',
    slug: 'husband-support-comics',
    title: '爸爸也来帮忙！超实用漫画教奶爸成为哺乳期神队友',
    excerpt: '哺乳不是妈妈一个人的事，爸爸的参与能让整个哺乳期变得轻松很多。来看看奶爸能做些什么成为真正的神队友。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=A%20father%20helping%20a%20breastfeeding%20mother%20by%20bringing%20water%20and%20pillows%2C%20supportive%20family%20scene%2C%20Japanese%20manga%20illustration%20style%2C%20soft%20warm%20colors%2C%20cozy%20home%20setting%2C%20heartwarming%20family%20moment&width=1600&height=900&seq=comic-art6-01&orientation=landscape', caption: '奶爸神队友的正确打开方式' },
      { type: 'paragraph', value: '很多爸爸觉得，喂奶是妈妈的事，自己帮不上忙。大错特错！一个好奶爸可以让妈妈的哺乳体验从"硬扛"变成"享受"。来看看爸爸们可以做什么。' },
      { type: 'subtitle', value: '神队友行动清单' },
      { type: 'paragraph', value: '1. 喂奶前：帮妈妈准备好靠垫、哺乳枕、水杯和手机。这些小事看起来不起眼，但妈妈抱着宝宝时真的很难自己去拿。' },
      { type: 'paragraph', value: '2. 喂奶中：给妈妈递水（母乳妈妈特别容易口渴），帮忙拿个毯子盖腿，或者就安静地坐在旁边陪伴。' },
      { type: 'paragraph', value: '3. 喂奶后：主动接过宝宝拍嗝，这是爸爸的专属任务！让妈妈能去上个洗手间或者活动一下僵硬的肩膀。' },
      { type: 'paragraph', value: '4. 夜里：虽然爸爸不能替妈妈喂奶，但可以负责换尿布、抱宝宝过来、喂完后再把宝宝放回小床。这些环节分担了妈妈大量的精力。' },
      { type: 'tip', value: '💡 小贴士：爸爸可以用奶瓶喂妈妈提前泵出来的母乳，这样妈妈可以获得连续几小时的睡眠。记得用"慢流速"奶嘴，模拟母乳喂养的节奏。' },
    ],
    categoryId: 'cat-5',
    coverImage: 'https://readdy.ai/api/search-image?query=Supportive%20husband%20helping%20wife%20during%20breastfeeding%2C%20family%20teamwork%2C%20Japanese%20manga%20art%20style%2C%20warm%20cozy%20home%20atmosphere%2C%20soft%20pastel%20colors%2C%20loving%20family%20moment&width=800&height=500&seq=comic-art6-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-04-12',
    readTime: 5,
    tags: ['奶爸', '哺乳期', '家庭支持', '育儿协作'],
    featured: false,
    viewCount: 14300,
  },
  {
    id: 'art-7',
    slug: 'breast-milk-storage-guide',
    title: '漫画图解：母乳储存与解冻完全指南，背奶妈妈必看',
    excerpt: '产假结束重返职场，母乳储存成了背奶妈妈的必修课。用清晰漫画图解告诉你母乳的储存、解冻和使用方法。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Educational%20illustration%20showing%20breast%20milk%20storage%20containers%20and%20labels%20in%20refrigerator%2C%20organized%20and%20clean%2C%20Japanese%20manga%20style%2C%20soft%20pastel%20colors%2C%20minimal%20clean%20background%2C%20practical%20guide&width=1600&height=900&seq=comic-art7-01&orientation=landscape', caption: '母乳储存方法图解' },
      { type: 'paragraph', value: '重返职场倒计时，最让我焦虑的不是工作本身，而是——怎么给宝宝存够口粮？作为过来人，今天用漫画把母乳储存的所有要点画出来，让背奶妈妈们心里有底。' },
      { type: 'subtitle', value: '储存容器怎么选' },
      { type: 'paragraph', value: '推荐使用专门的母乳储存袋，选择不含BPA的食品级材质。在袋子上用记号笔标注日期和奶量，按照"先进先出"的原则使用。玻璃或硬质塑料储奶瓶也是不错的选择，但占用空间较大。' },
      { type: 'subtitle', value: '储存时间一览表' },
      { type: 'paragraph', value: '室温（25℃以下）：4小时以内\n冷藏室（4℃）：3-5天\n冷冻室（-18℃以下）：3-6个月\n深冻冰柜（-20℃以下）：6-12个月' },
      { type: 'tip', value: '💡 小贴士：解冻母乳时千万不要用微波炉或直接煮沸！正确方法是提前一晚放冷藏室缓慢解冻，或者用流动温水（不超过40℃）冲淋。解冻后的母乳24小时内用完，不可再次冷冻。' },
      { type: 'paragraph', value: '另外，不同时间泵出的母乳可以混合存放，但要先把新鲜母乳在冷藏室冷却后再加入已冷藏的母乳中，避免温热的新奶使冷奶升温。' },
    ],
    categoryId: 'cat-6',
    coverImage: 'https://readdy.ai/api/search-image?query=Breast%20milk%20storage%20bags%20and%20bottles%20organized%20in%20freezer%2C%20educational%20cute%20illustration%2C%20Japanese%20manga%20style%2C%20soft%20pastel%20colors%2C%20clean%20organized%20look&width=800&height=500&seq=comic-art7-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-04-18',
    readTime: 6,
    tags: ['母乳储存', '背奶', '职场妈妈', '图解'],
    featured: false,
    viewCount: 25600,
  },
  {
    id: 'art-8',
    slug: 'weaning-journey-comics',
    title: '再见啦，奶奶：用漫画记录母子俩温柔而感伤的离乳之旅',
    excerpt: '离乳是一个充满复杂情感的里程碑。既是宝宝走向独立的标志，也是妈妈与宝宝最亲密时光的告别。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=A%20mother%20and%20toddler%20sharing%20a%20tender%20hug%20during%20weaning%20journey%2C%20bittersweet%20emotional%20moment%2C%20Japanese%20manga%20illustration%20style%2C%20soft%20warm%20golden%20hour%20light%2C%20pastel%20tones%2C%20gentle%20nostalgic%20atmosphere&width=1600&height=900&seq=comic-art8-01&orientation=landscape', caption: '温柔离乳的告别时刻' },
      { type: 'paragraph', value: '宝宝一岁半了，我开始认真考虑离乳这件事。身边的朋友有的说"自然离乳最好"，有的说"早点断了孩子睡得更好"。但我知道，这事没有标准答案，只有最适合我们母子俩的方式。' },
      { type: 'subtitle', value: '渐进式离乳日记' },
      { type: 'paragraph', value: '我们选择了最温和的方式——渐进式离乳。先从白天那顿开始减，用拥抱和讲故事来代替。第一周还算顺利，但轮到睡前那顿时，宝宝哭得撕心裂肺，我也跟着哭了。' },
      { type: 'paragraph', value: '那一刻我突然意识到：也许我比宝宝更舍不得这段哺乳时光。那些深夜里只有我们两个人的秘密约会，那些他边吃奶边用小手抓我衣领的触感，那些奶醉后满足的小表情——这些都要成为回忆了。' },
      { type: 'paragraph', value: '花了将近两个月的时间，我们终于完成了离乳。最后一顿奶的那天晚上，宝宝在我怀里安安静静地睡着了，没有哭闹。我看着他熟睡的小脸，眼泪不争气地流了下来，但心里更多的是骄傲——我的小宝贝长大了。' },
      { type: 'tip', value: '💡 小贴士：离乳期间妈妈要注意预防乳腺炎，建议逐渐减少哺乳次数而非突然停止。如果乳房胀痛，可以适当手挤排出一些以缓解不适，但不要排空。' },
    ],
    categoryId: 'cat-4',
    coverImage: 'https://readdy.ai/api/search-image?query=Mother%20and%20toddler%20embracing%20during%20sunset%2C%20weaning%20journey%2C%20bittersweet%20moment%2C%20Japanese%20manga%20art%20style%2C%20golden%20warm%20light%2C%20soft%20pastel%20colors%2C%20emotional%20tender%20scene&width=800&height=500&seq=comic-art8-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-04-25',
    readTime: 7,
    tags: ['离乳', '断奶', '育儿里程碑', '亲子情感'],
    featured: false,
    viewCount: 18200,
  },
  {
    id: 'art-9',
    slug: 'breastfeeding-positions-illustrated',
    title: '四大经典哺乳姿势漫画图解：找到最适合你和宝宝的姿势',
    excerpt: '摇篮式、橄榄球式、侧躺式、半躺式——四大经典哺乳姿势的漫画详解，帮助每位妈妈找到最舒适的喂养方式。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Four%20different%20breastfeeding%20positions%20illustrated%20in%20cute%20Japanese%20manga%20style%2C%20cradle%20hold%20football%20hold%20side%20lying%20laid%20back%2C%20educational%20diagram%2C%20soft%20pastel%20colors%2C%20warm%20clean%20background&width=1600&height=900&seq=comic-art9-01&orientation=landscape', caption: '四大经典哺乳姿势一览' },
      { type: 'paragraph', value: '你是不是也用同一个姿势喂奶喂到肩膀僵硬？其实哺乳姿势有很多种，换着用不仅能缓解疲劳，还能帮助解决堵奶、乳头疼痛等问题。今天来详细图解四大经典姿势。' },
      { type: 'subtitle', value: '1. 摇篮式（最常用）' },
      { type: 'paragraph', value: '这是最常见的哺乳姿势。妈妈坐直，用与哺乳乳房同侧的手臂托住宝宝，宝宝的头部枕在妈妈的臂弯里。适合：足月顺产宝宝、已经熟练掌握含乳的宝宝。' },
      { type: 'subtitle', value: '2. 橄榄球式（术后首选）' },
      { type: 'paragraph', value: '把宝宝夹在身体侧面，像夹一个橄榄球。妈妈用手托住宝宝的后颈，让宝宝从侧面含乳。适合：剖腹产妈妈（避免压到伤口）、双胞胎同时哺乳、乳房较大的妈妈。' },
      { type: 'subtitle', value: '3. 侧躺式（夜间救星）' },
      { type: 'paragraph', value: '妈妈和宝宝面对面侧躺，宝宝嘴巴与乳头在同一水平线上。适合：夜间哺乳、剖腹产恢复期、妈妈需要休息时。这个姿势让妈妈可以一边喂奶一边打盹。' },
      { type: 'subtitle', value: '4. 半躺式（生物养育法）' },
      { type: 'paragraph', value: '妈妈半躺（约45度），宝宝趴在妈妈胸口，利用重力自然含乳。适合：新生儿早期、含乳困难的宝宝、乳头扁平的妈妈。这个姿势利用宝宝的原始觅食反射，非常自然。' },
      { type: 'tip', value: '💡 小贴士：不要只固定用一种姿势！经常变换哺乳姿势可以让宝宝从不同角度吸吮，有助于排空乳房各个方向的乳腺管，预防堵奶和乳腺炎。' },
    ],
    categoryId: 'cat-6',
    coverImage: 'https://readdy.ai/api/search-image?query=Comparison%20of%20four%20breastfeeding%20positions%20cradle%20football%20side%20lying%20laid%20back%2C%20educational%20cute%20illustration%2C%20Japanese%20manga%20style%2C%20soft%20pastel%20colors%2C%20clean%20diagram&width=800&height=500&seq=comic-art9-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-05-02',
    readTime: 8,
    tags: ['哺乳姿势', '图解', '摇篮式', '橄榄球式'],
    featured: false,
    viewCount: 31200,
  },
  {
    id: 'art-10',
    slug: 'mom-groups-friendship',
    title: '哺乳群里认识的她：从奶量焦虑到月子餐分享的奇妙友谊',
    excerpt: '一个哺乳互助群，连接了三个素不相识的新手妈妈。从交流奶量到分享心事，她们在哺乳路上找到了彼此。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Three%20mothers%20chatting%20and%20laughing%20together%20in%20a%20cozy%20cafe%20with%20their%20babies%2C%20friendship%20bonding%2C%20Japanese%20manga%20illustration%20style%2C%20warm%20pastel%20colors%2C%20happy%20atmosphere%2C%20supportive%20community&width=1600&height=900&seq=comic-art10-01&orientation=landscape', caption: '哺乳群里认识的妈妈朋友们' },
      { type: 'paragraph', value: '产后第三周，因为奶量焦虑，我加入了一个本地母乳喂养互助群。刚开始只是在群里潜水，看大家讨论追奶方法。没想到，这个群后来成了我整个哺乳期最重要的精神支柱。' },
      { type: 'subtitle', value: '三个妈妈的故事' },
      { type: 'paragraph', value: '群里我认识了小薇和晓婷。小薇是个二胎妈妈，经验丰富，经常在群里解答我们的问题；晓婷和我一样是新手妈妈，宝宝比我家大半个月。我们三个人的宝宝年龄相仿，很快就聊到了一起。' },
      { type: 'paragraph', value: '从线上到线下，我们约了第一次见面。咖啡厅里，三个妈妈推着三辆婴儿车，聊到哺乳、婆媳、育儿理念、夫妻关系——话题一旦打开就收不住了。那种终于有人理解自己的感觉，真的太治愈了。' },
      { type: 'paragraph', value: '现在宝宝都一岁多了，我们的友谊也从"哺乳战友"升级成了真正的知己。我们一起经历了追奶、堵奶、离乳、复职——哺乳期虽然结束了，但这段因为哺乳结下的情谊会一直延续下去。' },
    ],
    categoryId: 'cat-5',
    coverImage: 'https://readdy.ai/api/search-image?query=Three%20young%20mothers%20with%20babies%20having%20coffee%20together%2C%20friendship%20and%20support%2C%20Japanese%20manga%20art%20style%2C%20warm%20cafe%20atmosphere%2C%20soft%20pastel%20colors%2C%20happy%20bonding%20moment&width=800&height=500&seq=comic-art10-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-05-10',
    readTime: 6,
    tags: ['哺乳群', '妈妈友谊', '育儿社交', '互助'],
    featured: false,
    viewCount: 11200,
  },
  {
    id: 'art-11',
    slug: 'pumping-at-work',
    title: '职场背奶日记：会议室、储藏间和母乳的100种泵奶场所',
    excerpt: '重返职场后，泵奶成了每天的必修课。从会议室到储藏间，背奶妈妈们的泵奶场所千奇百怪，但每一滴母乳都是爱的坚持。',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=A%20working%20mother%20pumping%20breast%20milk%20in%20a%20small%20office%20storage%20room%2C%20busy%20professional%20life%2C%20Japanese%20manga%20illustration%20style%2C%20soft%20warm%20colors%2C%20realistic%20workplace%20setting%2C%20dedication%20and%20love&width=1600&height=900&seq=comic-art11-01&orientation=landscape', caption: '职场妈妈的泵奶日常' },
      { type: 'paragraph', value: '产假结束第一天回到公司，我最紧张的不是工作交接，而是——在哪里泵奶？虽然有法律规定用人单位应该提供哺乳室，但现实是很多公司并没有完善的设施。' },
      { type: 'paragraph', value: '我的第一个泵奶场所是公司的储藏间。小小的空间里堆满了打印纸和办公用品，我坐在一个纸箱上，伴随着吸奶器嗡嗡的声音，一边泵奶一边回复工作邮件。后来在群里发现我不是一个人——有妈妈在车里泵、在空会议室泵、甚至还有在消防通道泵的。' },
      { type: 'subtitle', value: '那些哭笑不得的瞬间' },
      { type: 'paragraph', value: '最难忘的一次是正在储藏间泵奶，突然有同事来拿东西。我手忙脚乱地拔掉吸奶器，结果不小心打翻了一瓶刚泵好的奶。看着洒在地上的母乳，我蹲在那里哭了整整五分钟。那可是我辛辛苦苦攒的口粮啊。' },
      { type: 'tip', value: '💡 小贴士：建议背奶妈妈提前和公司沟通哺乳室的问题，可以申请使用空闲的小会议室或休息室。备一个便携式吸奶器、冰包和蓝冰，让背奶更高效。' },
    ],
    categoryId: 'cat-1',
    coverImage: 'https://readdy.ai/api/search-image?query=Working%20mother%20multitasking%20pumping%20and%20working%20at%20desk%2C%20professional%20mom%20life%2C%20Japanese%20manga%20style%2C%20soft%20warm%20colors%2C%20office%20setting&width=800&height=500&seq=comic-art11-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-05-15',
    readTime: 6,
    tags: ['职场背奶', '泵奶', '职场妈妈', '哺乳室'],
    featured: false,
    viewCount: 16700,
  },
  {
    id: 'art-12',
    slug: 'breastfeeding-diet-guide',
    title: '哺乳期妈妈吃什么？漫画版饮食指南帮你吃得营养又下奶',
    excerpt: '哺乳期到底什么能吃、什么不能吃？老一辈的经验和网上说法让人眼花缭乱。科学漫画饮食指南来啦！',
    content: [
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Colorful%20healthy%20food%20arrangement%20for%20breastfeeding%20mothers%2C%20nutritious%20meals%2C%20Japanese%20manga%20illustration%20style%2C%20fresh%20vibrant%20colors%2C%20soft%20pastel%20background%2C%20appetizing%20and%20healthy&width=1600&height=900&seq=comic-art12-01&orientation=landscape', caption: '哺乳期营养饮食推荐' },
      { type: 'paragraph', value: '"不能吃辣的，不然宝宝会上火！""多喝鲫鱼汤，下奶！""咖啡坚决不能喝！"——自从开始哺乳，耳边就充斥着各种饮食禁忌。但科学告诉我们，哺乳期饮食远没有那么可怕。' },
      { type: 'subtitle', value: '哺乳期可以吃的' },
      { type: 'paragraph', value: '富含蛋白质的食物：鱼、禽、蛋、瘦肉、豆制品\n全谷物：燕麦、糙米、小米（小米粥确实是下奶好帮手）\n蔬菜水果：尤其是深绿色叶菜和橙黄色蔬果\n健康脂肪：坚果、牛油果、橄榄油\n足量饮水：每天至少2000ml，喂奶前后各一杯' },
      { type: 'subtitle', value: '需要适量控制的' },
      { type: 'paragraph', value: '咖啡因：每天不超过300mg（约2杯咖啡），建议喂完奶再喝\n辛辣食物：大多数宝宝不受影响，但可以观察宝宝反应\n易产气食物：洋葱、卷心菜等可能让个别宝宝胀气' },
      { type: 'tip', value: '💡 小贴士：哺乳期不需要"一人吃两人份"，只需要比平时多摄入约500大卡即可。均衡饮食比大补特补更重要。每餐保证有主食、蛋白质和蔬菜就很棒了。' },
    ],
    categoryId: 'cat-2',
    coverImage: 'https://readdy.ai/api/search-image?query=Healthy%20breastfeeding%20diet%20illustration%20with%20nutritious%20foods%2C%20colorful%20fruits%20vegetables%20grains%2C%20Japanese%20manga%20style%2C%20fresh%20pastel%20colors%2C%20educational%20guide&width=800&height=500&seq=comic-art12-cover&orientation=landscape',
    author: '奶水漫画编辑部',
    publishDate: '2025-05-20',
    readTime: 6,
    tags: ['哺乳期饮食', '下奶食物', '营养', '饮食指南'],
    featured: false,
    viewCount: 28900,
  },
];

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: '奶水漫画的内容都是原创的吗？',
    answer: '是的，奶水漫画的内容以原创为主，由我们专业的漫画创作团队根据真实育儿经验和专业知识精心绘制。同时我们也会精选部分优质投稿作品，所有内容都经过专业审核，确保信息准确和画风一致。',
  },
  {
    id: 'faq-2',
    question: '如何判断宝宝是否吃饱了？',
    answer: '可以通过以下几个指标判断：1）每天有6-8片湿透的尿布；2）大便颜色从黑色胎便转变为黄色稀便；3）哺乳后乳房变软；4）宝宝吃完后安静满足；5）体重稳步增长。如果这些指标都正常，说明宝宝吃得很饱。',
  },
  {
    id: 'faq-3',
    question: '哺乳期感冒了还能喂奶吗？',
    answer: '可以！实际上感冒期间更应该继续哺乳。妈妈感冒时体内会产生抗体，这些抗体会通过母乳传递给宝宝，反而能增强宝宝的免疫力。但要注意戴口罩、勤洗手，避免通过呼吸道传播病毒给宝宝。如果服药，请先咨询医生选择哺乳期安全的药物。',
  },
  {
    id: 'faq-4',
    question: '奶水漫画多久更新一次？',
    answer: '我们保持每周更新2-3篇漫画内容，包括哺乳日常故事、育儿知识图解和趣味育儿漫画。你可以关注我们的社交媒体账号获取最新更新通知，也可以收藏网站定期查看新内容。',
  },
  {
    id: 'faq-5',
    question: '可以投稿自己的哺乳故事吗？',
    answer: '当然可以！我们非常欢迎妈妈们投稿分享自己的哺乳故事和育儿经验。你可以通过"关于我们"页面的联系方式发送你的故事，我们的创作团队会根据投稿内容进行漫画改编。被采用的故事会注明作者来源并赠送精美周边礼物。',
  },
  {
    id: 'faq-6',
    question: '宝宝长牙了咬乳头怎么办？',
    answer: '这是很多哺乳妈妈都会遇到的问题。当宝宝开始咬乳头时：1）保持冷静，不要大声喊叫吓到宝宝；2）用手指轻轻插入宝宝嘴角中断吸吮；3）坚定而温柔地说"不可以咬妈妈"；4）如果宝宝还想吃奶继续喂，如果反复咬就暂时停止哺乳。通常这个阶段是暂时的，宝宝很快会学会不咬。',
  },
];